webpackJsonp([1],{

/***/ "/aAs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0EqY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2y2i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EKE8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HP1U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I8Mw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2446261e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("0EqY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Framer.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Framer = ({
  name: 'Framer',
  props: ['bordersize']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4106668a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Framer.vue
var Framer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",class:{ large: _vm.bordersize === 'large' }},[_c('div',{staticClass:"side top"}),_vm._v(" "),_c('div',{staticClass:"side left"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"side right"}),_vm._v(" "),_c('div',{staticClass:"side bottom"})],2)}
var Framer_staticRenderFns = []
var Framer_esExports = { render: Framer_render, staticRenderFns: Framer_staticRenderFns }
/* harmony default export */ var components_Framer = (Framer_esExports);
// CONCATENATED MODULE: ./src/components/Framer.vue
function Framer_injectStyle (ssrContext) {
  __webpack_require__("2y2i")
}
var Framer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Framer___vue_template_functional__ = false
/* styles */
var Framer___vue_styles__ = Framer_injectStyle
/* scopeId */
var Framer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Framer___vue_module_identifier__ = null
var Framer_Component = Framer_normalizeComponent(
  Framer,
  components_Framer,
  Framer___vue_template_functional__,
  Framer___vue_styles__,
  Framer___vue_scopeId__,
  Framer___vue_module_identifier__
)

/* harmony default export */ var src_components_Framer = (Framer_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Finger.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Finger = ({
  name: 'Finger',
  data: function data() {
    return {
      show: true
    };
  },

  props: ['datum', 'canMove'],
  computed: {},
  methods: {
    removeHand: function removeHand() {
      console.log('moving over finger', this.canMove);
      if (this.canMove) {
        this.show = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var finger = document.getElementById('finger');
    finger.addEventListener('touchmove', function (e) {
      _this.removeHand();
    });
  },

  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ccbcb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finger.vue
var Finger_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"finger",attrs:{"id":"finger"},on:{"mousemove":function($event){_vm.removeHand()}}},[_c('img',{staticClass:"finger-icon",attrs:{"src":__webpack_require__("hq+g")}}),_vm._v(" "),_c('img',{staticClass:"choose-icon",attrs:{"src":__webpack_require__("wqBA")}}),_vm._v(" "),_c('div',{staticClass:"years"},[_c('div',{staticClass:"year-fore"},[_vm._v(_vm._s(_vm.datum['datum_fore']))]),_vm._v(" "),_c('div',{staticClass:"year-efter"},[_vm._v(_vm._s(_vm.datum['datum_efter']))])])]):_vm._e()}
var Finger_staticRenderFns = []
var Finger_esExports = { render: Finger_render, staticRenderFns: Finger_staticRenderFns }
/* harmony default export */ var components_Finger = (Finger_esExports);
// CONCATENATED MODULE: ./src/components/Finger.vue
function Finger_injectStyle (ssrContext) {
  __webpack_require__("wZxi")
}
var Finger_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Finger___vue_template_functional__ = false
/* styles */
var Finger___vue_styles__ = Finger_injectStyle
/* scopeId */
var Finger___vue_scopeId__ = "data-v-56ccbcb8"
/* moduleIdentifier (server only) */
var Finger___vue_module_identifier__ = null
var Finger_Component = Finger_normalizeComponent(
  Finger,
  components_Finger,
  Finger___vue_template_functional__,
  Finger___vue_styles__,
  Finger___vue_scopeId__,
  Finger___vue_module_identifier__
)

/* harmony default export */ var src_components_Finger = (Finger_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SplitVid.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SplitVid = ({
  name: 'SplitVid',
  data: function data() {
    return {
      splitId: Math.floor(9999 * Math.random()),
      firstMovId: Math.floor(9999 * Math.random()),
      firMovId: Math.floor(9999 * Math.random()),
      secMovId: Math.floor(9999 * Math.random()),
      firMovLargeId: Math.floor(9999 * Math.random()),
      secMovLargeId: Math.floor(9999 * Math.random()),
      vid1back: {},
      vid2back: {},
      msg: 'OnceNature',
      canPlay1: false,
      canPlay2: false,
      currentSize: 'small',
      syncedTimes: 0,
      syncedTimesLarge: 0,
      loader: {},
      loaded: 0,
      xhrrequests: [],
      canMove: false,
      isFullScreen: false,
      showInfoBox: false,
      muted: true
    };
  },

  props: ['firstsmall', 'secondsmall', 'first', 'second', 'firstback', 'secondback', 'datum', 'vimeoId', 'isIos', 'text'],
  computed: {
    canPlay: function canPlay() {
      if (this.canPlay1 && this.canPlay2) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {},
  methods: {
    toggleMuted: function toggleMuted() {
      this.muted = !this.muted;
    },
    makeNormalScreen: function makeNormalScreen() {
      var elem = document;
      //  console.log('making it normal', elem)
      if (elem.exitFullscreen) {
        elem.exitFullscreen();
        this.isFullScreen = false;
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
        this.isFullScreen = false;
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
        this.isFullScreen = false;
      }
    },
    makeFullScreen: function makeFullScreen() {
      var elem = document.getElementById(this.splitId);
      //  console.log('making it fullscreen', elem)
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
        this.isFullScreen = true;
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
        this.isFullScreen = true;
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
        this.isFullScreen = true;
      }
    },
    syncVideos: function syncVideos(vid1, vid2) {
      vid2.currentTime = vid1.currentTime;
      //  console.log('syncing', vid1)
      //  window.requestAnimationFrame(this.syncVideos(vid1, vid2))
    },
    downloadBackgrounds: function downloadBackgrounds() {
      var self = this;
      var back1 = new Image();
      back1.src = this.firstback;
      var back2 = new Image();
      back2.src = this.secondback;
      back1.onload = function () {
        self.vid1back.backgroundImage = 'url(' + back1.src + ')';
      };
      back2.onload = function () {
        console.log('Downloaded background-imagem2');
        self.vid2back.backgroundImage = 'url(' + back2.src + ')';
        self.downloadSmallVideos();
      };
    },
    downloadSmallVideos: function downloadSmallVideos() {
      var _this = this;

      console.log('Downloading small videos');
      promise_default.a.all([this.downloadVideo(this.firstsmall, this.firMovId, true), this.downloadVideo(this.secondsmall, this.secMovId, true)]).then(function (vals) {
        console.log('Downloaded both small videos');
        var vid1 = document.getElementById(_this.firMovId);
        var vid2 = document.getElementById(_this.secMovId);
        vid2.src = vals[1];
        vid1.src = vals[0];
        var play2 = vid2.play();
        var play1 = vid1.play();
        promise_default.a.all([play1, play2]).then(function () {
          //  console.log('downloaded small videos')
          _this.downloadVideos();
        }).catch(function (err) {
          console.log(err);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadVideos: function downloadVideos() {
      var _this2 = this;

      promise_default.a.all([this.downloadVideo(this.first, this.firMovLargeId, false), this.downloadVideo(this.second, this.secMovLargeId, false)]).then(function (vals) {
        var vidsmall1 = document.getElementById(_this2.firMovId);
        var vid1 = document.getElementById(_this2.firMovLargeId);
        var vid2 = document.getElementById(_this2.secMovLargeId);
        vid1.src = vals[0];
        vid2.src = vals[1];
        var play1 = vid1.play();
        var play2 = vid2.play();
        window.setTimeout(function () {
          _this2.currentSize = 'large';
          var vid1Small = document.getElementById(_this2.firMovId);
          var vid2Small = document.getElementById(_this2.secMovId);
          vid1Small.volume = 0;
          vid2Small.volume = 0;
          vid1Small.pause();
          vid2Small.pause();
        }, 1000);
        promise_default.a.all([play1, play2]).then(function () {
          vid1.currentTime = vidsmall1.currentTime + 0.1;
          vid2.currentTime = vidsmall1.currentTime + 0.1;
          //  console.log('downloaded and playing large videos')
        }).catch(function (err) {
          console.log(err);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadVideo: function downloadVideo(url, id, first) {
      var _this3 = this;

      var self = this;
      return new promise_default.a(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        self.xhrrequests.push(xhr);
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.addEventListener('progress', function (evt) {
          if (first) {
            _this3.loader[id] = evt.loaded / evt.total * 100;
            _this3.loaded = Math.round(0.5 * keys_default()(_this3.loader).map(function (key) {
              return _this3.loader[key];
            }).reduce(function (a, v) {
              return a + v;
            }, 0));
          }
        });
        xhr.onload = function (e) {
          if (this.status === 200) {
            var myBlob = this.response;
            var vid = (window.webkitURL ? window.webkitURL : window.URL).createObjectURL(myBlob);
            //  var video = document.getElementById(id)
            //  video.src = vid
            console.log('Downloaded === ' + id);
            resolve(vid);
          } else {
            reject(Error('Did not find file'));
          }
        };
        xhr.onerror = function () {
          reject(Error('Network error'));
        };
        xhr.onabort = function () {
          console.log('Aborted download');
          reject(Error('Aborted'));
        };
        xhr.send();
      });
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this4 = this;

    var self = this;
    window.setTimeout(function () {
      self.canMove = true;
    }, 1000);
    //  console.log('mounted with ', this.firstsmall)
    var container = document.getElementById(this.splitId);
    var videoDiv = document.getElementById(this.firstMovId);
    this.$nextTick(function () {
      //  this.downloadSmallVideos()
      _this4.downloadBackgrounds();
    });
    var vid1 = document.getElementById(this.firMovId);
    var vid2 = document.getElementById(this.secMovId);
    var vid1Large = document.getElementById(this.firMovLargeId);
    var vid2Large = document.getElementById(this.secMovLargeId);
    this.$nextTick(function () {
      videoDiv.style.width = container.offsetWidth / 2 + 'px';
    });
    vid2.addEventListener('timeupdate', function () {
      if (_this4.syncedTimes < 3 && vid1.currentTime > 0.6) {
        //  console.log('syncing small', vid1.currentTime + ' -- ' + vid2.currentTime)
        var setToThis = vid1.currentTime;
        vid1.currentTime = setToThis;
        vid2.currentTime = setToThis;
        _this4.syncedTimes++;
      }
      if (vid1.currentTime <= 0.6) {
        _this4.syncedTimes = 0;
      }
      //  console.log('')
    });
    vid2Large.addEventListener('timeupdate', function () {
      if (_this4.syncedTimesLarge < 3 && vid1Large.currentTime > 0.6) {
        // console.log('sycning large', vid1Large.currentTime + ' -- ' + vid2Large.currentTime)
        var setToThis = vid2Large.currentTime;
        vid1Large.currentTime = setToThis;
        vid2Large.currentTime = setToThis;
        _this4.syncedTimesLarge++;
      }
      if (vid1Large.currentTime <= 0.6) {
        _this4.syncedTimesLarge = 0;
      }
      //  console.log('got timeupdate event')
    });
    container.onmousemove = function (e) {
      if (!_this4.canMove) {
        return;
      }
      var w = e.pageX - container.offsetLeft;
      var total = container.offsetWidth;
      var proc = w / total;
      if (proc > 1) {
        proc = 1;
      }
      if (proc < 0.1) {
        proc = 0;
      }
      vid1.volume = proc;
      vid1Large.volume = proc;
      var largeProc = 1 - w / total;
      if (largeProc > 1) {
        largeProc = 1;
      }
      if (largeProc < 0.1) {
        largeProc = 0;
      }
      vid2Large.volume = largeProc;
      vid2.volume = largeProc;
      videoDiv.style.width = w + 'px';
    };
    container.onmouseout = function (e) {
      document.body.className = '';
    };
    container.onmouseover = function (e) {
      document.body.className = 'dissar-active';
    };
    container.addEventListener('touchmove', function (e) {
      if (!_this4.canMove) {
        return;
      }
      var touch = e.touches[0];
      var w = touch.pageX - container.offsetLeft;
      var total = container.offsetWidth;
      var proc = w / total;
      vid1.volume = proc;
      vid1Large.volume = proc;
      if (proc < 0.1) {
        vid1Large.volume = 0;
        vid1.volume = 0;
      }
      vid2Large.volume = 1 - proc;
      vid2.volume = 1 - proc;
      videoDiv.style.width = w + 'px';
    });

    if (window.innerWidth < 1100) {
      vid1.muted = true;
      vid2.muted = true;
      vid1Large.muted = true;
      vid2Large.muted = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.xhrrequests.map(function (a) {
      a.abort();
      //  console.log('aborting ', a)
      return {};
    });
    var container = document.getElementById(this.splitId);
    var videoDiv = document.getElementById(this.firstMovId);
    videoDiv.style.width = container.offsetWidth / 2 + 'px';
  },

  components: { Finger: src_components_Finger }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b68afa5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SplitVid.vue
var SplitVid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-vid",class:{ 'fullscreen' : _vm.isFullScreen },attrs:{"id":_vm.splitId}},[(!_vm.isFullScreen && !_vm.isIos)?_c('div',{staticClass:"show-fullscreen",on:{"click":function($event){_vm.makeFullScreen()}}}):_vm._e(),_vm._v(" "),(_vm.isFullScreen && !_vm.isIos)?_c('div',{staticClass:"dis-fullscreen",on:{"click":function($event){_vm.makeNormalScreen()}}}):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"show-info",on:{"click":function($event){_vm.showInfoBox = !_vm.showInfoBox}}},[_vm._v("?")]):_vm._e(),_vm._v(" "),(_vm.showInfoBox)?_c('div',{staticClass:"show-info-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.showInfoBox = !_vm.showInfoBox}}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"muted-button",class:{ muted: _vm.muted},on:{"click":function($event){_vm.toggleMuted()}}}):_vm._e(),_vm._v(" "),(_vm.loaded < 100 && !_vm.isIos)?_c('div',{staticClass:"loaded-nr"},[_vm._v(_vm._s(this.loaded)+"%")]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('Finger',{attrs:{"datum":_vm.datum,"can-move":_vm.canMove}}):_vm._e(),_vm._v(" "),(_vm.isIos)?_c('div',{staticClass:"movie-container"},[_c('div',{staticClass:"vimeo-container"},[_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":'https://player.vimeo.com/video/' + _vm.vimeoId + '?title=0&byline=0&portrait=0',"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"movie-container first",attrs:{"id":_vm.firstMovId}},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'small'),expression:"currentSize === 'small'"}],staticClass:"split-source",style:(_vm.vid1back),attrs:{"id":_vm.firMovId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}}),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'large'),expression:"currentSize === 'large'"}],staticClass:"split-source",attrs:{"id":_vm.firMovLargeId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}})]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"movie-container"},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'small'),expression:"currentSize === 'small'"}],staticClass:"split-source",style:(_vm.vid2back),attrs:{"id":_vm.secMovId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}}),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'large'),expression:"currentSize === 'large'"}],staticClass:"split-source",attrs:{"id":_vm.secMovLargeId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}})]):_vm._e()],1)}
var SplitVid_staticRenderFns = []
var SplitVid_esExports = { render: SplitVid_render, staticRenderFns: SplitVid_staticRenderFns }
/* harmony default export */ var components_SplitVid = (SplitVid_esExports);
// CONCATENATED MODULE: ./src/components/SplitVid.vue
function SplitVid_injectStyle (ssrContext) {
  __webpack_require__("EKE8")
}
var SplitVid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SplitVid___vue_template_functional__ = false
/* styles */
var SplitVid___vue_styles__ = SplitVid_injectStyle
/* scopeId */
var SplitVid___vue_scopeId__ = "data-v-5b68afa5"
/* moduleIdentifier (server only) */
var SplitVid___vue_module_identifier__ = null
var SplitVid_Component = SplitVid_normalizeComponent(
  SplitVid,
  components_SplitVid,
  SplitVid___vue_template_functional__,
  SplitVid___vue_styles__,
  SplitVid___vue_scopeId__,
  SplitVid___vue_module_identifier__
)

/* harmony default export */ var src_components_SplitVid = (SplitVid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HeaderMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var HeaderMenu = ({
  name: 'HeaderMenu',
  data: function data() {
    return {
      msg: 'OnceNature',
      ont: false,
      texter: {
        intro: '',
        contribute: '',
        embed: '',
        donateAmount: 10
      }
    };
  },

  methods: {
    toggleOn: function toggleOn() {
      this.ont = !this.ont;
    },
    checkout: function checkout() {
      /* this.$checkout.open({
        name: 'Once Nature',
        currency: 'USD',
        amount: this.donateAmount,
        token (token) {
          console.log(token)
        }
      }) */
      return false;
    }
  },
  mounted: function mounted() {
    this.texter = window.content()['texter'];
  },

  components: { Framer: src_components_Framer }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79466201","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderMenu.vue
var HeaderMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"logo"},[_vm._v("OnceNature")]),_vm._v(" "),(_vm.ont !== true && true === false)?_c('div',{staticClass:"info",on:{"click":_vm.toggleOn}},[_c('framer',{attrs:{"bordersize":"small"}},[_vm._v("\n      info\n    ")])],1):_c('div',{staticClass:"info-menu"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.texter.intro)}}),_vm._v(" "),_c('div',{staticClass:"light-but",attrs:{"id":"contribute"}},[_c('framer',{staticClass:"intro-buts",attrs:{"bordersize":"small"}},[_vm._v("Contribute")]),_vm._v(" "),_c('div',{staticClass:"dropup"},[_c('framer',{attrs:{"bordersize":"large"}},[_vm._v("\n                Contribute"),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.texter.contribute)}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"light-but right-float",attrs:{"id":"embed"}},[_c('framer',{staticClass:"intro-buts",attrs:{"bordersize":"small"}},[_vm._v("Embed")]),_vm._v(" "),_c('div',{staticClass:"dropup"},[_c('framer',{attrs:{"bordersize":"large"}},[_vm._v("\n                Embed"),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.texter.embed)}})])],1)],1)])])}
var HeaderMenu_staticRenderFns = []
var HeaderMenu_esExports = { render: HeaderMenu_render, staticRenderFns: HeaderMenu_staticRenderFns }
/* harmony default export */ var components_HeaderMenu = (HeaderMenu_esExports);
// CONCATENATED MODULE: ./src/components/HeaderMenu.vue
function HeaderMenu_injectStyle (ssrContext) {
  __webpack_require__("/aAs")
}
var HeaderMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HeaderMenu___vue_template_functional__ = false
/* styles */
var HeaderMenu___vue_styles__ = HeaderMenu_injectStyle
/* scopeId */
var HeaderMenu___vue_scopeId__ = "data-v-79466201"
/* moduleIdentifier (server only) */
var HeaderMenu___vue_module_identifier__ = null
var HeaderMenu_Component = HeaderMenu_normalizeComponent(
  HeaderMenu,
  components_HeaderMenu,
  HeaderMenu___vue_template_functional__,
  HeaderMenu___vue_styles__,
  HeaderMenu___vue_scopeId__,
  HeaderMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_HeaderMenu = (HeaderMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      onAMovie: false,
      msg: 'OnceNature',
      showinfo: false,
      contentData: [],
      vidnr: 0,
      transtype: 'list',
      isIos: false
    };
  },

  props: ['videonr'],
  computed: {},
  methods: {
    toggleInfo: function toggleInfo(nr) {
      if (nr === this.showinfo) {
        this.showinfo = false;
      } else {
        this.showinfo = nr;
      }
    },
    moveRight: function moveRight() {
      this.transtype = 'list';
      this.vidnr++;
      //  console.log('moveright', this.vidnr)
      if (this.vidnr > 5) {
        this.vidnr = 0;
      }
    },
    moveLeft: function moveLeft() {
      this.transtype = 'list2';
      //  console.log('moveleft')
      this.vidnr--;
      if (this.vidnr < 0) {
        this.vidnr = 5;
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.videonr) {
      this.vidnr = this.videonr - 1;
    }
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      this.isIos = true;
    }
  },
  mounted: function mounted() {
    //  console.log('videonr: ', this.videonr)
    this.contentData = window.content();
    //  console.log(window.content())
    console.log('version', '1.1.0');
  },

  components: { SplitVid: src_components_SplitVid, HeaderMenu: src_components_HeaderMenu, Framer: src_components_Framer }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e32f908","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-menu',{staticClass:"dissa"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transtype,"mode":"out-in"}},_vm._l((_vm.contentData.videos),function(data,index){return (index === parseInt(_vm.vidnr))?_c('div',{key:index,staticClass:"hello",class:{ firstcil: index === 0 }},[_c('split-vid',{attrs:{"firstsmall":data['film_liten_fore'],"secondsmall":data['film_liten_efter'],"first":data['film_stor_fore'],"second":data['film_stor_efter'],"firstback":data['bakgrundsbild_fore'],"secondback":data['bakgrundsbild_efter'],"datum":data['datum'],"vimeo-id":data['vimeo_id'],"is-ios":_vm.isIos,"text":data['info_text_short']}}),_vm._v(" "),_c('framer',{staticClass:"move-left dissa",attrs:{"bordersize":"small"},nativeOn:{"click":function($event){return _vm.moveLeft($event)}}},[_vm._v("<")]),_vm._v(" "),_c('framer',{staticClass:"move-right dissa",attrs:{"bordersize":"small"},nativeOn:{"click":function($event){return _vm.moveRight($event)}}},[_vm._v(">")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"what dissa",on:{"click":function($event){_vm.toggleInfo(index)}}},[(_vm.showinfo !== index)?_c('framer',{staticClass:"extra",attrs:{"bordersize":"small"}},[_vm._v("?")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"what-open"},[(_vm.showinfo === index)?_c('framer',{attrs:{"bordersize":"large"}},[_c('div',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();_vm.toggleInfo(index)}}},[_vm._v("✕")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(data['info_text'])}})]):_vm._e()],1)],1)],1):_vm._e()}))],1)}
var HelloWorld_staticRenderFns = []
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var components_HelloWorld = (HelloWorld_esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function HelloWorld_injectStyle (ssrContext) {
  __webpack_require__("HP1U")
  __webpack_require__("Tim7")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = "data-v-7e32f908"
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SplitVidFull.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SplitVidFull = ({
  name: 'SplitVid',
  data: function data() {
    return {
      splitId: Math.floor(9999 * Math.random()),
      firstMovId: Math.floor(9999 * Math.random()),
      firMovId: Math.floor(9999 * Math.random()),
      secMovId: Math.floor(9999 * Math.random()),
      firMovLargeId: Math.floor(9999 * Math.random()),
      secMovLargeId: Math.floor(9999 * Math.random()),
      vid1back: {},
      vid2back: {},
      msg: 'OnceNature',
      canPlay1: false,
      canPlay2: false,
      currentSize: 'small',
      syncedTimes: 0,
      syncedTimesLarge: 0,
      loader: {},
      loaded: 0,
      xhrrequests: [],
      canMove: false,
      isFullScreen: false,
      showInfoBox: false,
      muted: true
    };
  },

  props: ['firstsmall', 'secondsmall', 'first', 'second', 'firstback', 'secondback', 'datum', 'vimeoId', 'isIos', 'text'],
  computed: {
    canPlay: function canPlay() {
      if (this.canPlay1 && this.canPlay2) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {},
  methods: {
    toggleMuted: function toggleMuted() {
      this.muted = !this.muted;
    },
    makeNormalScreen: function makeNormalScreen() {
      var elem = document;
      if (elem.exitFullscreen) {
        elem.exitFullscreen();
        this.isFullScreen = false;
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
        this.isFullScreen = false;
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
        this.isFullScreen = false;
      }
    },
    makeFullScreen: function makeFullScreen() {
      var elem = document.getElementById(this.splitId);
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
        this.isFullScreen = true;
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
        this.isFullScreen = true;
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
        this.isFullScreen = true;
      }
    },
    syncVideos: function syncVideos(vid1, vid2) {
      vid2.currentTime = vid1.currentTime;
      //  console.log('syncing', vid1)
      //  window.requestAnimationFrame(this.syncVideos(vid1, vid2))
    },
    downloadBackgrounds: function downloadBackgrounds() {
      var self = this;
      var back1 = new Image();
      back1.src = this.firstback;
      var back2 = new Image();
      back2.src = this.secondback;
      back1.onload = function () {
        self.vid1back.backgroundImage = 'url(' + back1.src + ')';
      };
      back2.onload = function () {
        // console.log('Downloaded background-imagem2')
        self.vid2back.backgroundImage = 'url(' + back2.src + ')';
        self.downloadSmallVideos();
      };
    },
    downloadSmallVideos: function downloadSmallVideos() {
      var _this = this;

      // console.log('Downloading small videos')
      promise_default.a.all([this.downloadVideo(this.firstsmall, this.firMovId, true), this.downloadVideo(this.secondsmall, this.secMovId, true)]).then(function (vals) {
        // console.log('Downloaded both small videos')
        var vid1 = document.getElementById(_this.firMovId);
        var vid2 = document.getElementById(_this.secMovId);
        vid2.src = vals[1];
        vid1.src = vals[0];
        var play2 = vid2.play();
        var play1 = vid1.play();
        promise_default.a.all([play1, play2]).then(function () {
          //  console.log('downloaded small videos')
          _this.downloadVideos();
        }).catch(function (err) {
          console.log(err);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadVideos: function downloadVideos() {
      var _this2 = this;

      promise_default.a.all([this.downloadVideo(this.first, this.firMovLargeId, false), this.downloadVideo(this.second, this.secMovLargeId, false)]).then(function (vals) {
        var vidsmall1 = document.getElementById(_this2.firMovId);
        var vid1 = document.getElementById(_this2.firMovLargeId);
        var vid2 = document.getElementById(_this2.secMovLargeId);
        vid1.src = vals[0];
        vid2.src = vals[1];
        var play1 = vid1.play();
        var play2 = vid2.play();
        window.setTimeout(function () {
          _this2.currentSize = 'large';
          var vid1Small = document.getElementById(_this2.firMovId);
          var vid2Small = document.getElementById(_this2.secMovId);
          vid1Small.volume = 0;
          vid2Small.volume = 0;
          vid1Small.pause();
          vid2Small.pause();
        }, 1000);
        promise_default.a.all([play1, play2]).then(function () {
          vid1.currentTime = vidsmall1.currentTime + 0.1;
          vid2.currentTime = vidsmall1.currentTime + 0.1;
          //  console.log('downloaded and playing large videos')
        }).catch(function (err) {
          console.log(err);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadVideo: function downloadVideo(url, id, first) {
      var _this3 = this;

      var self = this;
      return new promise_default.a(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        self.xhrrequests.push(xhr);
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.addEventListener('progress', function (evt) {
          if (first) {
            _this3.loader[id] = evt.loaded / evt.total * 100;
            _this3.loaded = Math.round(0.5 * keys_default()(_this3.loader).map(function (key) {
              return _this3.loader[key];
            }).reduce(function (a, v) {
              return a + v;
            }, 0));
          }
        });
        xhr.onload = function (e) {
          if (this.status === 200) {
            var myBlob = this.response;
            var vid = (window.webkitURL ? window.webkitURL : window.URL).createObjectURL(myBlob);
            //  var video = document.getElementById(id)
            //  video.src = vid
            console.log('Downloaded === ' + id);
            resolve(vid);
          } else {
            reject(Error('Did not find file'));
          }
        };
        xhr.onerror = function () {
          reject(Error('Network error'));
        };
        xhr.onabort = function () {
          console.log('Aborted download');
          reject(Error('Aborted'));
        };
        xhr.send();
      });
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this4 = this;

    var self = this;
    window.setTimeout(function () {
      self.canMove = true;
    }, 1000);
    //  console.log('mounted with ', this.firstsmall)
    var container = document.getElementById(this.splitId);
    var videoDiv = document.getElementById(this.firstMovId);
    this.$nextTick(function () {
      //  this.downloadSmallVideos()
      _this4.downloadBackgrounds();
    });
    var vid1 = document.getElementById(this.firMovId);
    var vid2 = document.getElementById(this.secMovId);
    var vid1Large = document.getElementById(this.firMovLargeId);
    var vid2Large = document.getElementById(this.secMovLargeId);
    this.$nextTick(function () {
      videoDiv.style.width = container.offsetWidth / 2 + 'px';
    });
    vid2.addEventListener('timeupdate', function () {
      if (_this4.syncedTimes < 3 && vid1.currentTime > 0.6) {
        //  console.log('syncing small', vid1.currentTime + ' -- ' + vid2.currentTime)
        var setToThis = vid1.currentTime;
        vid1.currentTime = setToThis;
        vid2.currentTime = setToThis;
        _this4.syncedTimes++;
      }
      if (vid1.currentTime <= 0.6) {
        _this4.syncedTimes = 0;
      }
      //  console.log('')
    });
    vid2Large.addEventListener('timeupdate', function () {
      if (_this4.syncedTimesLarge < 3 && vid1Large.currentTime > 0.6) {
        // console.log('sycning large', vid1Large.currentTime + ' -- ' + vid2Large.currentTime)
        var setToThis = vid2Large.currentTime;
        vid1Large.currentTime = setToThis;
        vid2Large.currentTime = setToThis;
        _this4.syncedTimesLarge++;
      }
      if (vid1Large.currentTime <= 0.6) {
        _this4.syncedTimesLarge = 0;
      }
      //  console.log('got timeupdate event')
    });
    container.onmousemove = function (e) {
      if (!_this4.canMove) {
        return;
      }
      var w = e.pageX - container.offsetLeft;
      var total = container.offsetWidth;
      var proc = w / total;
      if (proc > 1) {
        proc = 1;
      }
      if (proc < 0.1) {
        proc = 0;
      }
      vid1.volume = proc;
      vid1Large.volume = proc;
      var largeProc = 1 - w / total;
      if (largeProc > 1) {
        largeProc = 1;
      }
      if (largeProc < 0.1) {
        largeProc = 0;
      }
      vid2Large.volume = largeProc;
      vid2.volume = largeProc;
      videoDiv.style.width = w + 'px';
    };
    container.onmouseout = function (e) {
      document.body.className = '';
    };
    container.onmouseover = function (e) {
      document.body.className = 'dissar-active';
    };
    container.addEventListener('touchmove', function (e) {
      if (!_this4.canMove) {
        return;
      }
      var touch = e.touches[0];
      var w = touch.pageX - container.offsetLeft;
      var total = container.offsetWidth;
      var proc = w / total;
      vid1.volume = proc;
      vid1Large.volume = proc;
      if (proc < 0.1) {
        vid1Large.volume = 0;
        vid1.volume = 0;
      }
      vid2Large.volume = 1 - proc;
      vid2.volume = 1 - proc;
      videoDiv.style.width = w + 'px';
    });

    if (window.innerWidth < 1100) {
      vid1.muted = true;
      vid2.muted = true;
      vid1Large.muted = true;
      vid2Large.muted = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.xhrrequests.map(function (a) {
      a.abort();
      //  console.log('aborting ', a)
      return {};
    });
    var container = document.getElementById(this.splitId);
    var videoDiv = document.getElementById(this.firstMovId);
    videoDiv.style.width = container.offsetWidth / 2 + 'px';
  },

  components: { Finger: src_components_Finger }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663332ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SplitVidFull.vue
var SplitVidFull_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-vid",class:{ 'fullscreen' : _vm.isFullScreen },attrs:{"id":_vm.splitId}},[(!_vm.isFullScreen && !_vm.isIos)?_c('div',{staticClass:"show-fullscreen",on:{"click":function($event){_vm.makeFullScreen()}}}):_vm._e(),_vm._v(" "),(_vm.isFullScreen && !_vm.isIos)?_c('div',{staticClass:"dis-fullscreen",on:{"click":function($event){_vm.makeNormalScreen()}}}):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"show-info",on:{"click":function($event){_vm.showInfoBox = !_vm.showInfoBox}}},[_vm._v("?")]):_vm._e(),_vm._v(" "),(_vm.showInfoBox)?_c('div',{staticClass:"show-info-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.showInfoBox = !_vm.showInfoBox}}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"muted-button",class:{ muted: _vm.muted},on:{"click":function($event){_vm.toggleMuted()}}}):_vm._e(),_vm._v(" "),(_vm.loaded < 100 && !_vm.isIos)?_c('div',{staticClass:"loaded-nr"},[_vm._v(_vm._s(this.loaded)+"%")]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('Finger',{attrs:{"datum":_vm.datum,"can-move":_vm.canMove}}):_vm._e(),_vm._v(" "),(_vm.isIos)?_c('div',{staticClass:"movie-container"},[_c('div',{staticClass:"vimeo-container"},[_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":'https://player.vimeo.com/video/' + _vm.vimeoId + '?title=0&byline=0&portrait=0',"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"movie-container first",attrs:{"id":_vm.firstMovId}},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'small'),expression:"currentSize === 'small'"}],staticClass:"split-source",style:(_vm.vid1back),attrs:{"id":_vm.firMovId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}}),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'large'),expression:"currentSize === 'large'"}],staticClass:"split-source",attrs:{"id":_vm.firMovLargeId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}})]):_vm._e(),_vm._v(" "),(!_vm.isIos)?_c('div',{staticClass:"movie-container"},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'small'),expression:"currentSize === 'small'"}],staticClass:"split-source",style:(_vm.vid2back),attrs:{"id":_vm.secMovId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}}),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSize === 'large'),expression:"currentSize === 'large'"}],staticClass:"split-source",attrs:{"id":_vm.secMovLargeId,"preload":"auto","loop":"","autobuffer":""},domProps:{"muted":_vm.muted}})]):_vm._e()],1)}
var SplitVidFull_staticRenderFns = []
var SplitVidFull_esExports = { render: SplitVidFull_render, staticRenderFns: SplitVidFull_staticRenderFns }
/* harmony default export */ var components_SplitVidFull = (SplitVidFull_esExports);
// CONCATENATED MODULE: ./src/components/SplitVidFull.vue
function SplitVidFull_injectStyle (ssrContext) {
  __webpack_require__("I8Mw")
}
var SplitVidFull_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SplitVidFull___vue_template_functional__ = false
/* styles */
var SplitVidFull___vue_styles__ = SplitVidFull_injectStyle
/* scopeId */
var SplitVidFull___vue_scopeId__ = "data-v-663332ea"
/* moduleIdentifier (server only) */
var SplitVidFull___vue_module_identifier__ = null
var SplitVidFull_Component = SplitVidFull_normalizeComponent(
  SplitVidFull,
  components_SplitVidFull,
  SplitVidFull___vue_template_functional__,
  SplitVidFull___vue_styles__,
  SplitVidFull___vue_scopeId__,
  SplitVidFull___vue_module_identifier__
)

/* harmony default export */ var src_components_SplitVidFull = (SplitVidFull_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Embedder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Embedder = ({
  name: 'Embedder',
  data: function data() {
    return {
      dataEm: null,
      isIos: false
    };
  },

  props: [],
  computed: {
    vid: function vid() {
      return this.$route.query.vid || false;
    }
  },
  methods: {},
  beforeMount: function beforeMount() {
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      this.isIos = true;
    }
  },
  mounted: function mounted() {
    this.dataEm = window.content().videos[this.vid - 1];
    //  console.log('id', this.vid)
    //  console.log('data', this.dataEm)
  },

  components: { SplitVid: src_components_SplitVidFull }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cff5a5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Embedder.vue
var Embedder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"once-nature-embedder"},[(_vm.dataEm !== null)?_c('split-vid',{attrs:{"firstsmall":_vm.dataEm['film_liten_fore'],"secondsmall":_vm.dataEm['film_liten_efter'],"first":_vm.dataEm['film_stor_fore'],"second":_vm.dataEm['film_stor_efter'],"firstback":_vm.dataEm['bakgrundsbild_fore'],"secondback":_vm.dataEm['bakgrundsbild_efter'],"datum":_vm.dataEm['datum'],"vimeo-id":_vm.dataEm['vimeo_id'],"is-ios":_vm.isIos,"text":_vm.dataEm['info_text_short']}}):_vm._e()],1)}
var Embedder_staticRenderFns = []
var Embedder_esExports = { render: Embedder_render, staticRenderFns: Embedder_staticRenderFns }
/* harmony default export */ var components_Embedder = (Embedder_esExports);
// CONCATENATED MODULE: ./src/components/Embedder.vue
function Embedder_injectStyle (ssrContext) {
  __webpack_require__("nV8S")
}
var Embedder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Embedder___vue_template_functional__ = false
/* styles */
var Embedder___vue_styles__ = Embedder_injectStyle
/* scopeId */
var Embedder___vue_scopeId__ = "data-v-7cff5a5e"
/* moduleIdentifier (server only) */
var Embedder___vue_module_identifier__ = null
var Embedder_Component = Embedder_normalizeComponent(
  Embedder,
  components_Embedder,
  Embedder___vue_template_functional__,
  Embedder___vue_styles__,
  Embedder___vue_scopeId__,
  Embedder___vue_module_identifier__
)

/* harmony default export */ var src_components_Embedder = (Embedder_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HelloWorld',
    component: src_components_HelloWorld
  }, {
    path: '/vid/:videonr',
    name: 'HelloWorldSpecific',
    props: true,
    component: src_components_HelloWorld
  }, {
    path: '/embed',
    name: 'Embedder',
    component: src_components_Embedder
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



//  import VueStripeCheckout from 'vue-stripe-checkout'

vue_esm["a" /* default */].config.productionTip = false;
//  test pk_test_OlQ8pK9OWiWKOYIlWXBMuMxT
var options = {
  //  key: 'pk_test_OlQ8pK9OWiWKOYIlWXBMuMxT',
  image: 'http://oncenature.org/img/paybild.png',
  locale: 'auto',
  currency: 'USD',
  billingAddress: false,
  panelLabel: 'Donate {{amount}}'
};
console.log(options);
//  Vue.use(VueStripeCheckout, options)

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Tim7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hq+g":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNTM0cHgiIGhlaWdodD0iNjU4cHgiIHZpZXdCb3g9IjAgMCA1MzQgNjU4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MzQgNjU4IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIGZpbGw9IiNCQ0JFQzAiIHN0cm9rZT0iIzQxNDA0MiIgc3Ryb2tlLXdpZHRoPSIxNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjA2LDQwNw0KCWMtMzIuODE0LTMuNTY0LTUxLjQxMS0yNi40Mi03Ny4zMzItNDcuMzM4QzEwOC4xNzEsMzQzLjEyMSw3NC44MDksMjk1LjUxMiw0MiwzMjNjLTM3LDMxLDIwLjMzNSw3Mi4yOSwzOCw4OQ0KCWMzNywzNSw0MC4xNjYsNjguMzc1LDY4LDk0YzIyLjQ1MSwyMC42NjksNTUuNjY3LDQyLjQ4LDYyLjYxOCw1MS40OTdjMTAuNzgsMTMuOTgzLDcuNzA5LDQ5LjMwOSw4Ljc3NSw2Ny43MDMNCgljMTAuNjA2LDguOCwxMDUuMDg0LDExLjQ2NywxMjkuMjUsMTAuMjRDMzkxLjYsNjMzLjI2LDQ1Miw2MjksNDU4LjA0NCw2MjEuMjUyYzEuMTY3LTI3LjMzNS00LjkyLTUzLjkzNSwxMC4wMzctNzcuNDg0DQoJYzExLjAxOS0xNy4zNTEsMjYuNzc1LTMxLjI1OCwzMy43My01Ni43NTVjNi4zNjMtMjMuMzI3LDQuNTQ0LTgxLjIyLDMuMTg4LTEzOC4wMTNjLTEuNjY2LTY5LjgzOSwwLTEzOC0zNS0xMzgNCgljLTM2LjQyNCwwLjAwMi0zMC42MzcsNzcuNzQyLTMwLjYzNywxMTAuMTY0QzQzOS4zNjMsMjkxLjk2MSw0NDUsMTkwLDQwNCwxOTFjLTQxLjUwNCwxLjAxMy0zOC4wNDgsODguNjU1LTQxLDEyOQ0KCWMtMi4zNjUtMzkuOTQ0LDIwLjIxNS0xMzQuODQ4LTM0LTEzNGMtNDUuNDAyLDAuNzEtMzcuOTQ1LDEwMy43MDktNDEsMTM1Yy0xLjMxLTMyLjQ1NS0yLTE1OS0zLTIwOWMtMC45MzItNDYuNjAyLTAuOTg0LTg1LTM0LTg1DQoJYy00MCwwLTM3LjQwOCw1OS45MjEtMzgsODNjLTEsMzktMC4xNTIsMTM2LjY2OS0xLDE1N0MyMTIsMjY3LDIxMCwzNjgsMjA2LDQwN3oiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "nV8S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wZxi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqBA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b2655da6b93153268e5b.js